import React from 'react'
import { cx } from '@emotion/css'
import { toggleInputCss, toggleCss, disabledToggleCss } from './shared'

interface Props {
  readonly disabled?: boolean
  readonly checked: boolean
  readonly onChange: () => void
  e2eId?: string
}

export const toggleTestID = 'toggle-test-id'

export function Toggle({ disabled, checked, onChange, e2eId }: Props) {
  return (
    <label>
      <input
        className={toggleInputCss}
        type="checkbox"
        disabled={disabled}
        checked={checked}
        onChange={onChange}
        data-testid={toggleTestID}
      />
      <i
        className={cx(toggleCss, { [disabledToggleCss]: disabled })}
        data-e2e={e2eId}
      />
    </label>
  )
}
